import { t } from "@transifex/native";
import { z } from "zod";

export const loginSchema = z.object({
  email: z.string().email(t("Invalid email format")).min(5, t("Email must be at least 5 characters")),
  password: z.string().min(8, t("Password must be at least 8 characters")),
});

export const signUpSchema = z
  .object({
    email: z.string().email(t("Invalid email format")).min(5, t("Email must be at least 5 characters")),
    phone: z
      .string({
        message: t("Please provide a valid phone number"),
      })
      .regex(/\d{11}/, t("Please provide a valid phone number")),
    password: z
      .string()
      .min(8, t("Password must be at least 8 characters"))
      .regex(/[A-Z]/, t("Password must include an uppercase letter"))
      .regex(/[a-z]/, t("Password must include a lowercase letter"))
      .regex(/\d/, t("Password must include a number"))
      .regex(/[@$!%*?&#]/, t("Password must include a special character"))
      .regex(/^\S.*\S$/, t("Password must not start or end with a space")),
    confirmPassword: z.string().min(8, t("Confirm password must match the password")),
    first: z.string().min(1, t("First name is required")),
    last: z.string().min(1, t("Last name is required")),
  })
  .refine((data) => data.password === data.confirmPassword, {
    path: ["confirmPassword"],
    message: t("Passwords must match"),
  });

export const profileSchema = z.object({
  email: z.string().email(t("Invalid email format")).min(5, t("Email must be at least 5 characters")),
  phone: z
    .string({
      message: t("Please provide a valid phone number"),
    })
    .regex(/\d{11}/, t("Please provide a valid phone number")),
  first: z.string().min(1, t("First name is required")),
  last: z.string().min(1, t("Last name is required")),
});

export const forgotPasswordSchema = z.object({
  email: z.string().email(t("Invalid email format")).min(5, t("Email must be at least 5 characters")),
});

export const newPasswordSchema = z
  .object({
    first: z.string().min(1, t("First name is required")),
    last: z.string().min(1, t("Last name is required")),
    newPassword: z
      .string()
      .min(8, t("Password must be at least 8 characters"))
      .regex(/[A-Z]/, t("Password must include an uppercase letter"))
      .regex(/[a-z]/, t("Password must include a lowercase letter"))
      .regex(/\d/, t("Password must include a number"))
      .regex(/[@$!%*?&#]/, t("Password must include a special character"))
      .regex(/^\S.*\S$/, t("Password must not start or end with a space")),
    newPasswordConfirmation: z.string().min(8, t("Confirm password must match the password")),
    phone: z
      .string({
        message: t("Please provide a valid phone number"),
      })
      .regex(/\d{11}/, t("Please provide a valid phone number")),
  })
  .refine((data) => data.newPassword === data.newPasswordConfirmation, {
    message: t("Passwords must match"),
    path: ["newPasswordConfirmation"],
  });

export const resetPasswordSchema = z
  .object({
    code: z.string().length(6, t("Verification code must be exactly 6 digits")),
    newPassword: z
      .string()
      .min(8, t("Password must be at least 8 characters"))
      .regex(/[A-Z]/, t("Password must include an uppercase letter"))
      .regex(/[a-z]/, t("Password must include a lowercase letter"))
      .regex(/\d/, t("Password must include a number"))
      .regex(/[@$!%*?&#]/, t("Password must include a special character")),
    confirmNewPassword: z.string().min(8, t("Confirm password must match the password")),
  })
  .refine((data) => data.newPassword === data.confirmNewPassword, {
    path: ["confirmNewPassword"],
    message: t("Passwords must match"),
  });

export const verifyCodeSchema = z.object({
  code: z
    .string()
    .length(6, t("The verification code must be exactly 6 digits"))
    .regex(/^\d{6}$/, t("The verification code must only contain digits")),
});

export const changePasswordSchema = z
  .object({
    oldPassword: z.string().min(8, t("Old password must be at least 8 characters")),
    newPassword: z
      .string()
      .min(8, t("Password must be at least 8 characters"))
      .regex(/[A-Z]/, t("Password must include an uppercase letter"))
      .regex(/[a-z]/, t("Password must include a lowercase letter"))
      .regex(/\d/, t("Password must include a number"))
      .regex(/[@$!%*?&#]/, t("Password must include a special character")),
    confirmNewPassword: z.string().min(8, t("Confirm password must match the password")),
  })
  .refine((data) => data.newPassword === data.confirmNewPassword, {
    path: ["confirmNewPassword"],
    message: t("Passwords must match"),
  });
